import digitalData from 'digital-data';

export const userFeedback = () => {
    window.LIFE_CYCLE_EVENT_BUS.on('user-feedback.click', ({ output = {} }) => {
        const {
            primaryCategory = '',
            eventName = '',
            sessionID = '',
            question = '',
            actionID = '',
            feedback = ''
        } = output;
        const thdAnalyticsEvent = {
            category: {
                primaryCategory
            },
            eventInfo: {
                eventName
            },
            sessionID,
            actionID,
            question,
            feedback
        };
        digitalData.event = digitalData.event || [];
        digitalData.event.push(thdAnalyticsEvent);
    });

    window.LIFE_CYCLE_EVENT_BUS.on('user-feedback.comment', ({ output = {} }) => {
        const {
            primaryCategory = '',
            eventName = '',
            sessionID = '',
            question = '',
            actionID = '',
            feedbackComment = ''
        } = output;
        const thdAnalyticsEvent = {
            category: {
                primaryCategory
            },
            eventInfo: {
                eventName
            },
            sessionID,
            actionID,
            question,
            feedbackComment
        };
        digitalData.event = digitalData.event || [];
        digitalData.event.push(thdAnalyticsEvent);
    });
}

